var map = {
	"./1stServe-medal.svg": 539,
	"./ComingSoonHeader.svg": 540,
	"./add-friend-icon.svg": 541,
	"./add-participants-icon.svg": 542,
	"./akar-arrow-right.svg": 543,
	"./anpc-sal.svg": 544,
	"./anpc-sol.svg": 545,
	"./apple-icon.svg": 546,
	"./arrow-down-white.svg": 547,
	"./arrow-down.svg": 234,
	"./arrow-left.svg": 548,
	"./arrow-right.svg": 235,
	"./arrow-slide-left.svg": 549,
	"./arrow-slide-right.svg": 550,
	"./arrow/right-button-arrow.svg": 551,
	"./arrow/right-link-arrow.svg": 552,
	"./arrow/yellow-down.svg": 553,
	"./availableSlot-icon.svg": 236,
	"./back-arrow-2.svg": 554,
	"./back-arrow.svg": 555,
	"./bahrain-flag-icon.svg": 556,
	"./balls/diadem-premier-clay-court.jpg": 557,
	"./balls/dunlop-australian-open.jpg": 558,
	"./balls/dunlop-fort-all-court.jpg": 559,
	"./balls/head-atp.jpg": 560,
	"./balls/head-tour.jpg": 561,
	"./balls/official-ball.png": 562,
	"./balls/padel-head-tour.png": 563,
	"./balls/padel-nox.png": 564,
	"./balls/padel-suix.png": 565,
	"./balls/padel-wilson.png": 566,
	"./balls/wilson-rolland-garros-all-court.jpg": 567,
	"./balls/wilson-tour-premier-all-court.jpg": 568,
	"./balls/wilson-us-open.jpg": 569,
	"./banners/asic.png": 570,
	"./banners/babolat.png": 571,
	"./banners/first.png": 572,
	"./banners/fourth.png": 573,
	"./banners/nikeshoes.png": 574,
	"./banners/salbatica.png": 575,
	"./banners/second.png": 576,
	"./banners/tenniswarehouse-clashv2.jpg": 577,
	"./banners/third.png": 578,
	"./banners/tpfb.png": 579,
	"./banners/twe.png": 580,
	"./bar-icon.svg": 581,
	"./bell-icon-elipse.svg": 582,
	"./bell-icon-white-elipse.svg": 583,
	"./bell-icon-white.svg": 584,
	"./bell-icon.svg": 585,
	"./bg-findplayer.png": 586,
	"./bg-set-availability.png": 130,
	"./bg-set-favorite-sport.png": 237,
	"./bg-set-game-level.png": 587,
	"./bg-set-profile-picture.png": 588,
	"./bg-set-profile-visibility.png": 238,
	"./bg/ClubBanner.svg": 589,
	"./bg/bannerPromo.png": 590,
	"./bg/bg1.png": 591,
	"./bg/bg2.png": 592,
	"./bg/bg3.png": 593,
	"./bg/bg4.png": 594,
	"./bg/event_bg1.png": 595,
	"./bg/event_bg2.png": 596,
	"./bg/event_bg3.png": 597,
	"./bg/event_bg4.png": 598,
	"./bg/event_bg5.png": 599,
	"./bg/event_bg_default1.svg": 600,
	"./bg/event_bg_default2.svg": 601,
	"./bg/event_page_bg1.png": 602,
	"./bg/logo1.png": 603,
	"./bg/soon.svg": 239,
	"./bg/virtualWalletAvailable.svg": 240,
	"./bg/virtualWalletNegative.svg": 241,
	"./bg/virtualWalletUnavailable.svg": 242,
	"./bg1.png": 604,
	"./bg2.png": 605,
	"./bg3.png": 606,
	"./black-arrow-down.svg": 607,
	"./black-cancel-request-icon.svg": 608,
	"./black-clock-icon.svg": 609,
	"./black-line.svg": 610,
	"./black-right-arrow-small.svg": 611,
	"./block-icon.svg": 612,
	"./blocked-red-icon.svg": 613,
	"./blue-line-icon.svg": 614,
	"./bulgaria-flag-icon.svg": 615,
	"./cafeteria-icon.svg": 616,
	"./calendar-icon-turqoise.svg": 617,
	"./calendar-icon.svg": 618,
	"./campaign/banner-bg.png": 619,
	"./campaign/banners/duracell_1225x150px.png": 620,
	"./campaign/banners/duracell_1225x220px.png": 621,
	"./campaign/banners/lindab_1225x150px.jpg": 622,
	"./campaign/banners/lindab_1225x220px.png": 623,
	"./campaign/banners/organicindia_1225x150px.png": 624,
	"./campaign/banners/organicindia_1225x220px.jpg": 625,
	"./campaign/banners/pringles_150x1225px.jpg": 626,
	"./campaign/banners/pringles_220x1225px.jpg": 627,
	"./campaign/banners/tenis10_1225x150px.jpg": 628,
	"./campaign/banners/tenis10_1225x220px.jpg": 629,
	"./campaign/bg.png": 630,
	"./campaign/bg2.png": 631,
	"./campaign/blackserama/d-bg.jpg": 632,
	"./campaign/blackserama/m-bg.jpg": 633,
	"./campaign/calendar.png": 634,
	"./campaign/player.png": 635,
	"./campaign/romania-joaca-tenis/bg-mobile.png": 636,
	"./campaign/romania-joaca-tenis/bg-slim-banner.png": 637,
	"./campaign/romania-joaca-tenis/bg.png": 638,
	"./campaign/romania-joaca-tenis/flag.png": 639,
	"./campaign/romania-joaca-tenis/right-arrow.svg": 640,
	"./campaign/romania-joaca-tenis/vaillant.png": 641,
	"./campaign/savings.png": 642,
	"./campaign/star.png": 643,
	"./cancel-new-chat-icon.svg": 644,
	"./cancel-request-icon.svg": 645,
	"./cells-icon.svg": 646,
	"./champion-icon-turqoise.svg": 647,
	"./champions-category-icon.svg": 648,
	"./champions-medal.svg": 649,
	"./change-photo.svg": 650,
	"./chat-icon.svg": 651,
	"./chat-white-icon.svg": 652,
	"./checkmark-arrow.svg": 653,
	"./checkmark-big.svg": 654,
	"./checkmark-black.svg": 655,
	"./checkmark-blue.svg": 656,
	"./checkmark-bold.svg": 657,
	"./checkmark-draw.svg": 658,
	"./checkmark-gold.svg": 659,
	"./checkmark-outline.svg": 660,
	"./checkmark-white.svg": 83,
	"./checkmark.svg": 243,
	"./chevron-down-icon.svg": 661,
	"./chevron-up-icon.svg": 662,
	"./close-icon.svg": 663,
	"./close-red-icon.svg": 664,
	"./close-white-icon.svg": 665,
	"./club-logo.png": 666,
	"./clubPhoto.svg": 667,
	"./clubs/amenities/Bar.svg": 668,
	"./clubs/amenities/Cafeteria.svg": 669,
	"./clubs/amenities/EquipmentRental.svg": 670,
	"./clubs/amenities/FreeParking.svg": 671,
	"./clubs/amenities/KidsPlayground.svg": 672,
	"./clubs/amenities/Lockers.svg": 673,
	"./clubs/amenities/PaidParking.svg": 674,
	"./clubs/amenities/Restaurant.svg": 675,
	"./clubs/amenities/Showers.svg": 676,
	"./clubs/amenities/SpecialAccess.svg": 677,
	"./clubs/amenities/Store.svg": 678,
	"./clubs/amenities/VendingMachine.svg": 679,
	"./clubs/court-type.svg": 680,
	"./clubs/refund-icon.svg": 681,
	"./clubs/self-service-icon.svg": 682,
	"./clubs/sportya-partner-club.svg": 683,
	"./cog-icon.svg": 684,
	"./coins-img.png": 685,
	"./collapse.svg": 686,
	"./coming-soon.png": 687,
	"./comingsoon-visuals/booking.png": 688,
	"./comingsoon-visuals/elipse.svg": 689,
	"./comingsoon-visuals/eventsManagement.png": 690,
	"./comingsoon-visuals/friendly-matches.svg": 691,
	"./comingsoon-visuals/globe.svg": 692,
	"./comingsoon-visuals/liveScores.png": 693,
	"./comingsoon-visuals/meetYourMatch.png": 694,
	"./comingsoon-visuals/messages-2.svg": 695,
	"./comingsoon-visuals/messages.svg": 696,
	"./comingsoon-visuals/news.png": 697,
	"./comingsoon-visuals/stay-tuned.svg": 698,
	"./confirm-friend-icon.svg": 699,
	"./conversations-big-icon.svg": 700,
	"./conversations-icon.svg": 701,
	"./copy-red.svg": 702,
	"./copy.svg": 703,
	"./crown-icon.svg": 704,
	"./discount-icon-black.png": 705,
	"./discount-icon.png": 706,
	"./discount-icon.svg": 707,
	"./donate-icon.svg": 244,
	"./down-arrow.svg": 708,
	"./dslr-camera.svg": 709,
	"./edit-icon.svg": 710,
	"./email-icon.svg": 711,
	"./empty-image.svg": 712,
	"./equipment-icon.svg": 713,
	"./event-logo.png": 714,
	"./events/eventDetails/partner_club.svg": 715,
	"./events/featuredEvents/arrow-left.png": 716,
	"./events/featuredEvents/arrow-right.png": 717,
	"./events/joinCompetition/close.svg": 718,
	"./events/joinCompetition/lfp-button.svg": 719,
	"./events/joinCompetition/tennis-racket.svg": 720,
	"./events/minus-icon-followed-events.svg": 721,
	"./events/x-icon-followed-events.svg": 722,
	"./expand.svg": 723,
	"./external-link.svg": 724,
	"./eye-icon.svg": 725,
	"./facebook-icon-black.svg": 726,
	"./facebook-icon-rounded-black.svg": 727,
	"./facebook-icon.svg": 728,
	"./facebook-letter.svg": 729,
	"./file-icon.svg": 730,
	"./filter-icon.svg": 731,
	"./filter.svg": 732,
	"./find-an-event-bg.png": 733,
	"./findAnEvent-icon/no-results-banner.svg": 734,
	"./firstServe-category-icon.svg": 735,
	"./firstplace-medal.svg": 736,
	"./flags/am.svg": 737,
	"./flags/armenia.svg": 738,
	"./flags/bahrain.svg": 739,
	"./flags/bg-border.svg": 740,
	"./flags/bg.svg": 741,
	"./flags/bh-border.svg": 742,
	"./flags/bh.svg": 743,
	"./flags/bulgaria.svg": 744,
	"./flags/cz-border.svg": 745,
	"./flags/cz.svg": 746,
	"./flags/czech.svg": 747,
	"./flags/hu-border.svg": 748,
	"./flags/hu.svg": 749,
	"./flags/hungary.svg": 750,
	"./flags/md-border.svg": 751,
	"./flags/md.svg": 752,
	"./flags/moldova.svg": 753,
	"./flags/ro-border.svg": 754,
	"./flags/ro.svg": 755,
	"./flags/romania.svg": 756,
	"./forplayers-visuals/first-visual.png": 757,
	"./forplayers-visuals/for-players-header.png": 758,
	"./forplayers-visuals/fourth-visual.png": 759,
	"./forplayers-visuals/learn-more/Header.svg": 760,
	"./forplayers-visuals/learn-more/Vector.png": 761,
	"./forplayers-visuals/learn-more/header-visual.svg": 762,
	"./forplayers-visuals/learn-more/logo-tenispartener.png": 763,
	"./forplayers-visuals/learn-more/sportya-symbol.svg": 764,
	"./forplayers-visuals/second-visual.png": 765,
	"./forplayers-visuals/symbol-logo.png": 766,
	"./forplayers-visuals/third-visual.png": 767,
	"./free-parking-icon.svg": 768,
	"./free-plan-icon.svg": 769,
	"./friend-confirmed-icon.svg": 770,
	"./friendly-matches-guide/contact.svg": 771,
	"./friendly-matches-guide/playedMatches.svg": 772,
	"./friendly-matches-guide/ranked.svg": 773,
	"./friendly-matches-guide/scores.svg": 774,
	"./friendly-matches-guide/unranked.svg": 775,
	"./friendly-matches-guide/withdrawals.svg": 776,
	"./friendly-matches/acceptance/accepted-icon.svg": 777,
	"./friendly-matches/acceptance/declined-icon.svg": 778,
	"./friendly-matches/acceptance/noMatch-icon.svg": 779,
	"./friendly-matches/acceptance/pending-icon.svg": 780,
	"./friendly-matches/acceptance/withdrawn-icon.svg": 781,
	"./friendly-matches/alert-icon.svg": 782,
	"./friendly-matches/black-palette.svg": 783,
	"./friendly-matches/info-red.svg": 784,
	"./friendly-matches/info.svg": 785,
	"./friendly-matches/landing/bg.png": 786,
	"./friendly-matches/landing/elevate-skills.png": 787,
	"./friendly-matches/landing/flex-play.png": 788,
	"./friendly-matches/landing/friendly-matches.png": 789,
	"./friendly-matches/landing/match-found.png": 790,
	"./friendly-matches/landing/raise-hand.png": 791,
	"./friendly-matches/match-form/avatar-placeholder.svg": 792,
	"./friendly-matches/match-form/average-level-doubles.svg": 793,
	"./friendly-matches/match-form/average-level-singles.svg": 794,
	"./friendly-matches/match-form/back-arrow.svg": 795,
	"./friendly-matches/match-form/calendar-icon.svg": 796,
	"./friendly-matches/match-form/checkmark-ellipse.svg": 797,
	"./friendly-matches/match-form/location-icon.svg": 798,
	"./friendly-matches/match-form/tennis-ball-icon-white.svg": 799,
	"./friendly-matches/match-form/tennis-ball-icon.svg": 800,
	"./friendly-matches/match-form/tennis-racket-icon.svg": 801,
	"./friendly-matches/match-form/time-icon.svg": 802,
	"./friendly-matches/matches/button-chat.svg": 803,
	"./friendly-matches/matches/button-dropdown.svg": 804,
	"./friendly-matches/matches/button-dropup.svg": 805,
	"./friendly-matches/matches/button-more.svg": 806,
	"./friendly-matches/matches/chat.svg": 807,
	"./friendly-matches/matches/doubles-match.svg": 808,
	"./friendly-matches/matches/placeholder-avatar.png": 809,
	"./friendly-matches/matches/plus-icon.svg": 810,
	"./friendly-matches/matches/ranked-match.svg": 811,
	"./friendly-matches/matches/singles-match.svg": 812,
	"./friendly-matches/matches/x-icon.svg": 813,
	"./friendly-matches/no-friendly-matches.png": 814,
	"./friendly-matches/pending-icon.svg": 815,
	"./friendly-matches/quick-guide-icon.svg": 816,
	"./friendly-matches/reg-banner.png": 817,
	"./friendly-matches/start-match/banner-bg-mobile.png": 818,
	"./friendly-matches/start-match/banner-bg.png": 819,
	"./friendly-matches/start-match/button-circle-plus-white.svg": 820,
	"./friendly-matches/start-match/button-circle-plus.svg": 821,
	"./friendly-matches/start-match/button-invite.svg": 822,
	"./friendly-matches/start-match/button-rematch.svg": 823,
	"./friendly-matches/start-match/button-right-arrow.svg": 824,
	"./friendly-matches/start-match/button-trophy.svg": 825,
	"./friendly-matches/start-match/distance-radius.svg": 826,
	"./friendly-matches/start-match/friends.svg": 827,
	"./friendly-matches/start-match/placeholder-avatar.png": 828,
	"./friendly-matches/start-match/raised-hand.svg": 829,
	"./friendly-matches/start-match/search-player-banner-bg.png": 830,
	"./friendly-matches/tabs/scores.svg": 831,
	"./friendly-matches/tabs/start-friendly-match.svg": 832,
	"./friendly-matches/tabs/tennis-ball.svg": 833,
	"./friendly-matches/tabs/tennis-racket-checkmark.svg": 834,
	"./friendly-matches/tabs/tennis-racket-question-mark.svg": 835,
	"./friendly-matches/view-more-arrow.svg": 836,
	"./friendly-matches/white-palette.png": 837,
	"./friendly-matches/winner.svg": 838,
	"./friends-icon.svg": 839,
	"./getting-started-guide/arrow-left.svg": 840,
	"./getting-started-guide/arrow-right.svg": 841,
	"./getting-started-guide/bg-bottom.svg": 842,
	"./getting-started-guide/bg.png": 843,
	"./getting-started-guide/bg.svg": 844,
	"./getting-started-guide/content-box.svg": 845,
	"./getting-started-guide/dashboard-banner-mobile.svg": 846,
	"./getting-started-guide/dashboard-banner.svg": 847,
	"./getting-started-guide/guide-banner.png": 848,
	"./getting-started-guide/icon/chat.svg": 849,
	"./getting-started-guide/icon/compass.svg": 850,
	"./getting-started-guide/icon/formats.svg": 851,
	"./getting-started-guide/icon/match-formats.svg": 852,
	"./getting-started-guide/icon/packs.svg": 853,
	"./getting-started-guide/icon/ranked.svg": 854,
	"./getting-started-guide/icon/rockets.svg": 855,
	"./getting-started-guide/icon/trophy-award.svg": 856,
	"./getting-started-guide/icon/trophy.svg": 857,
	"./getting-started-guide/logo-flag.svg": 858,
	"./getting-started-guide/logo.png": 859,
	"./getting-started-guide/thumbnails/4.png": 860,
	"./getting-started-guide/thumbnails/5.png": 861,
	"./getting-started-guide/thumbnails/6.png": 862,
	"./getting-started-guide/thumbnails/7.png": 863,
	"./getting-started-guide/thumbnails/8.png": 864,
	"./getting-started-guide/thumbnails/9.png": 865,
	"./globe-icon.svg": 866,
	"./gold-category-icon.svg": 867,
	"./gold-medal.svg": 868,
	"./google-icon.svg": 869,
	"./green-clock-icon.svg": 870,
	"./green-up-arrow.svg": 871,
	"./hand-not-raised.svg": 872,
	"./hand-raised.svg": 873,
	"./header/free.svg": 874,
	"./header/level-badge.svg": 875,
	"./header/premium.svg": 876,
	"./header/x.svg": 877,
	"./homepage/court.png": 878,
	"./icon-bell.svg": 879,
	"./icon-friends.svg": 880,
	"./icon-wallet.svg": 881,
	"./icons/add-photo.svg": 882,
	"./icons/blackTbaIcon.svg": 883,
	"./icons/crown-dark.svg": 245,
	"./icons/crown-light.svg": 246,
	"./icons/free-account.svg": 884,
	"./icons/gold.svg": 885,
	"./icons/map-marker.svg": 886,
	"./icons/platinum.svg": 887,
	"./icons/premium-account.svg": 888,
	"./icons/silver.svg": 889,
	"./icons/summer-account.svg": 890,
	"./icons/whiteTbaIcon.svg": 891,
	"./info-icon.svg": 892,
	"./instagram-icon-black.svg": 893,
	"./instagram-icon.svg": 894,
	"./invite-friends-icon.png": 895,
	"./invite-friends-icon.svg": 896,
	"./invite-friends/bg-banner.svg": 897,
	"./invite-friends/bg.png": 898,
	"./invite-friends/og.png": 899,
	"./invite-friends/party-popper.svg": 900,
	"./kid-icon.svg": 901,
	"./leaderboard-down-arrow.svg": 902,
	"./leaderboard-no-arrow.svg": 903,
	"./leaderboard-up-arrow.svg": 904,
	"./league-category-icon.svg": 905,
	"./league-medal.svg": 906,
	"./leave-group-chat-icon.svg": 907,
	"./level-badge.svg": 908,
	"./location-icon-turqoise.svg": 909,
	"./location-icon.svg": 910,
	"./locker-icon.svg": 911,
	"./logo-white-small.svg": 912,
	"./logo-white.svg": 913,
	"./logo.svg": 914,
	"./mail-icon.svg": 915,
	"./maintenance/Under Maintenance.gif": 916,
	"./manage-cog-icon.svg": 917,
	"./map-black.svg": 918,
	"./mapspin-icon.svg": 919,
	"./medal-icon.svg": 920,
	"./medal.svg": 921,
	"./megafone.svg": 922,
	"./men-icon.svg": 923,
	"./mgm/avatar-placeholder.png": 924,
	"./mgm/check-circle.png": 925,
	"./mgm/item1.png": 926,
	"./mgm/item2.png": 927,
	"./mgm/item3.png": 928,
	"./mgm/item4.png": 929,
	"./mgm/refer-via-bg.png": 930,
	"./migration.png": 931,
	"./mixt-icon.svg": 932,
	"./modal-check-icon.svg": 933,
	"./moldova-flag-icon.svg": 934,
	"./mpg-logo.svg": 935,
	"./muted-bell-icon.svg": 936,
	"./navigationBlackArrow.svg": 937,
	"./navigationBlueArrow.svg": 938,
	"./new-chat-icon.svg": 939,
	"./no-friend-requests-icon.svg": 940,
	"./notFound-visuals/404-visual.png": 941,
	"./notFound-visuals/bg.png": 942,
	"./official-ball.png": 943,
	"./onboarding/bg-set-game-level.png": 944,
	"./onboarding/bg-set-profile-details.png": 945,
	"./onboarding/bg-set-profile-picture.png": 946,
	"./onboarding/camera.svg": 947,
	"./onboarding/uploaded.svg": 948,
	"./page-link.svg": 949,
	"./pagination-left-arrow.svg": 950,
	"./pagination-right-arrow.svg": 951,
	"./paid-parking-icon.svg": 952,
	"./payUlogo.svg": 953,
	"./payu-green-logo.svg": 954,
	"./pdf-icon.svg": 955,
	"./pencil.svg": 956,
	"./pending-clock.svg": 957,
	"./person-icon.svg": 958,
	"./phone-icon.svg": 959,
	"./placeholder-conversation.svg": 960,
	"./placeholders/padel-champions-cover.png": 961,
	"./placeholders/padel-champions-featured.png": 962,
	"./placeholders/padel-champions-logo.png": 963,
	"./placeholders/padel-champions-thumbnail.png": 964,
	"./placeholders/padel-firstServe-cover.png": 965,
	"./placeholders/padel-firstServe-featured.png": 966,
	"./placeholders/padel-firstServe-logo.png": 967,
	"./placeholders/padel-firstServe-thumbnail.png": 968,
	"./placeholders/padel-gold-cover.png": 969,
	"./placeholders/padel-gold-featured.png": 970,
	"./placeholders/padel-gold-logo.png": 971,
	"./placeholders/padel-gold-thumbnail.png": 972,
	"./placeholders/padel-league-cover.png": 973,
	"./placeholders/padel-league-featured.png": 974,
	"./placeholders/padel-league-logo.png": 975,
	"./placeholders/padel-league-thumbnail.png": 976,
	"./placeholders/padel-platinum-cover.png": 977,
	"./placeholders/padel-platinum-featured.png": 978,
	"./placeholders/padel-platinum-logo.png": 979,
	"./placeholders/padel-platinum-thumbnail.png": 980,
	"./placeholders/padel-silver-cover.png": 981,
	"./placeholders/padel-silver-featured.png": 982,
	"./placeholders/padel-silver-logo.png": 983,
	"./placeholders/padel-silver-thumbnail.png": 984,
	"./placeholders/padel-special-cover.png": 985,
	"./placeholders/padel-special-featured.png": 986,
	"./placeholders/padel-special-logo.png": 987,
	"./placeholders/padel-special-thumbnail.png": 988,
	"./placeholders/placeholder-champions-cover.svg": 989,
	"./placeholders/placeholder-champions-featured.svg": 990,
	"./placeholders/placeholder-champions-logo.svg": 991,
	"./placeholders/placeholder-champions-thumbnail.svg": 992,
	"./placeholders/placeholder-firstServe-cover.svg": 993,
	"./placeholders/placeholder-firstServe-featured.svg": 994,
	"./placeholders/placeholder-firstServe-logo.svg": 995,
	"./placeholders/placeholder-firstServe-thumbnail.svg": 996,
	"./placeholders/placeholder-gold-cover.svg": 997,
	"./placeholders/placeholder-gold-featured.svg": 998,
	"./placeholders/placeholder-gold-logo.svg": 999,
	"./placeholders/placeholder-gold-thumbnail.svg": 1000,
	"./placeholders/placeholder-image-cover.svg": 1001,
	"./placeholders/placeholder-image-featured.svg": 1002,
	"./placeholders/placeholder-image-logo.svg": 1003,
	"./placeholders/placeholder-image-thumbnail.svg": 1004,
	"./placeholders/placeholder-league-cover.svg": 1005,
	"./placeholders/placeholder-league-featured.svg": 1006,
	"./placeholders/placeholder-league-logo.svg": 1007,
	"./placeholders/placeholder-league-thumbnail.svg": 1008,
	"./placeholders/placeholder-platinum-cover.svg": 1009,
	"./placeholders/placeholder-platinum-featured.svg": 1010,
	"./placeholders/placeholder-platinum-logo.svg": 1011,
	"./placeholders/placeholder-platinum-thumbnail.svg": 1012,
	"./placeholders/placeholder-silver-cover.svg": 1013,
	"./placeholders/placeholder-silver-featured.svg": 1014,
	"./placeholders/placeholder-silver-logo.svg": 1015,
	"./placeholders/placeholder-silver-thumbnail.svg": 1016,
	"./placeholders/placeholder-special-cover.svg": 1017,
	"./placeholders/placeholder-special-featured.svg": 1018,
	"./placeholders/placeholder-special-logo.svg": 1019,
	"./placeholders/placeholder-special-thumbnail.svg": 1020,
	"./placeholders/tennis-champions-cover.png": 1021,
	"./placeholders/tennis-champions-featured.png": 1022,
	"./placeholders/tennis-champions-logo.png": 1023,
	"./placeholders/tennis-champions-thumbnail.png": 1024,
	"./placeholders/tennis-firstServe-cover.png": 1025,
	"./placeholders/tennis-firstServe-featured.png": 1026,
	"./placeholders/tennis-firstServe-logo.png": 1027,
	"./placeholders/tennis-firstServe-thumbnail.png": 1028,
	"./placeholders/tennis-gold-cover.png": 1029,
	"./placeholders/tennis-gold-featured.png": 1030,
	"./placeholders/tennis-gold-logo.png": 1031,
	"./placeholders/tennis-gold-thumbnail.png": 1032,
	"./placeholders/tennis-league-cover.png": 1033,
	"./placeholders/tennis-league-featured.png": 1034,
	"./placeholders/tennis-league-logo.png": 1035,
	"./placeholders/tennis-league-thumbnail.png": 1036,
	"./placeholders/tennis-platinum-cover.png": 1037,
	"./placeholders/tennis-platinum-featured.png": 1038,
	"./placeholders/tennis-platinum-logo.png": 1039,
	"./placeholders/tennis-platinum-thumbnail.png": 1040,
	"./placeholders/tennis-silver-cover.png": 1041,
	"./placeholders/tennis-silver-featured.png": 1042,
	"./placeholders/tennis-silver-logo.png": 1043,
	"./placeholders/tennis-silver-thumbnail.png": 1044,
	"./placeholders/tennis-special-cover.png": 1045,
	"./placeholders/tennis-special-featured.png": 1046,
	"./placeholders/tennis-special-logo.png": 1047,
	"./placeholders/tennis-special-thumbnail.png": 1048,
	"./platinum-category-icon.svg": 1049,
	"./platinum-medal.svg": 1050,
	"./play-icon-black.svg": 1051,
	"./play-icon.svg": 1052,
	"./player-profile/add-friend.svg": 1053,
	"./player-profile/cancel-request.svg": 1054,
	"./player-profile/confirm-friend.svg": 1055,
	"./player-profile/friend-confirmed.svg": 1056,
	"./player-profile/manage-cog.svg": 1057,
	"./player-profile/star-rating-outline.svg": 1058,
	"./player-profile/star-rating.svg": 1059,
	"./player-profile/titles-tab/champions.svg": 1060,
	"./player-profile/titles-tab/firstServe.svg": 1061,
	"./player-profile/titles-tab/gold.svg": 1062,
	"./player-profile/titles-tab/league.svg": 1063,
	"./player-profile/titles-tab/platinum.svg": 1064,
	"./player-profile/titles-tab/silver.svg": 1065,
	"./player-profile/titles-tab/special.svg": 1066,
	"./playerBadge.svg": 1067,
	"./playersPhotos/player01.svg": 1068,
	"./playersPhotos/player02.svg": 1069,
	"./plus-icon.svg": 247,
	"./powered-by-stripe.svg": 1070,
	"./premium-account-icon.svg": 1071,
	"./premium-plan-icon.svg": 1072,
	"./premium-plan.svg": 1073,
	"./premium-time-plan.svg": 1074,
	"./products/product1.svg": 1075,
	"./radius-marker-icon.svg": 1076,
	"./rank-down-arrow-icon.svg": 1077,
	"./rank-no-arrow-icon.svg": 1078,
	"./rank-up-arrow-icon.svg": 1079,
	"./ranked.svg": 1080,
	"./rating-icon-outline.svg": 1081,
	"./rating-icon.svg": 1082,
	"./red-delete-icon.svg": 1083,
	"./red-logout-icon.svg": 1084,
	"./red-x-icon.svg": 1085,
	"./red-x-icon2.svg": 1086,
	"./rematch-icon.svg": 1087,
	"./report-icon.svg": 1088,
	"./reservedSlot-icon.svg": 248,
	"./restaurant-icon.svg": 1089,
	"./right-arrow-white.svg": 1090,
	"./right-arrow.svg": 1091,
	"./romania-flag-icon.svg": 1092,
	"./rows-icon.svg": 1093,
	"./rules/en/section4-img1.png": 1094,
	"./rules/en/section4-img2.png": 1095,
	"./rules/en/section8-img1.png": 1096,
	"./rules/en/section8-img2.png": 1097,
	"./rules/en/section8-img3.png": 1098,
	"./rules/en/section8-img4.png": 1099,
	"./rules/en/section8-img5.png": 1100,
	"./rules/en/section8-img6.png": 1101,
	"./rules/ro/section4-img1.png": 1102,
	"./rules/ro/section4-img2.png": 1103,
	"./rules/ro/section8-img1-deprecated.png": 1104,
	"./rules/ro/section8-img2.png": 1105,
	"./rules/ro/section8-img3.png": 1106,
	"./rules/ro/section8-img4.png": 1107,
	"./rules/ro/section8-img5.png": 1108,
	"./rules/ro/section8-img6.png": 1109,
	"./sample-image-placeholder.svg": 1110,
	"./search-friends-icon.svg": 1111,
	"./search-icon.svg": 1112,
	"./search-icon_black.svg": 1113,
	"./search-icon_white.svg": 1114,
	"./see-group-members-icon.svg": 1115,
	"./select-hour-icon-disabled.svg": 1116,
	"./select-hour-icon.svg": 1117,
	"./send-icon.svg": 1118,
	"./send-message-icon.png": 1119,
	"./send-message-icon.svg": 1120,
	"./send-new-message-icon.svg": 1121,
	"./shield-double.svg": 1122,
	"./shield-gold.svg": 1123,
	"./shield-silver.svg": 1124,
	"./shield.svg": 249,
	"./shower-icon.svg": 1125,
	"./silent-bell-icon.svg": 1126,
	"./silver-category-icon.svg": 1127,
	"./silver-crown.svg": 1128,
	"./silver-cup-icon.svg": 1129,
	"./slide1.svg": 1130,
	"./slide2.svg": 1131,
	"./slide3.svg": 1132,
	"./social-media/email.svg": 1133,
	"./social-media/facebook.svg": 1134,
	"./social-media/twitter.svg": 1135,
	"./special-access-icon.svg": 1136,
	"./special-category-icon.svg": 1137,
	"./special-medal.svg": 1138,
	"./sponsor-logo/specific-event/casa_timis.png": 1139,
	"./sponsor-logo/specific-event/casa_timis_new.png": 1140,
	"./sponsor-logo/specific-event/garmin.png": 1141,
	"./sponsor-logo/specific-event/gold-nutrition.png": 1142,
	"./sponsor-logo/specific-event/mega_image.png": 1143,
	"./sponsor-logo/specific-event/mega_image_new.png": 1144,
	"./sponsor-logo/specific-event/nikon.png": 1145,
	"./sponsor-logo/specific-event/radox.png": 1146,
	"./sponsor-logo/sponsor1.png": 1147,
	"./sponsor-logo/sponsor2.png": 1148,
	"./sponsor-logo/sponsor3.png": 1149,
	"./sponsor-logo/sponsor4.png": 1150,
	"./sponsors-coordinators/coordinator_1.png": 1151,
	"./sponsors-coordinators/coordinator_2.png": 1152,
	"./sponsors-coordinators/official_sponsor_2.png": 1153,
	"./sponsors-coordinators/official_store.png": 1154,
	"./sponsors-coordinators/sponsor_10.png": 1155,
	"./sponsors-coordinators/sponsor_11.png": 1156,
	"./sponsors-coordinators/sponsor_12.png": 1157,
	"./sponsors-coordinators/sponsor_13.png": 1158,
	"./sponsors-coordinators/sponsor_14.png": 1159,
	"./sponsors-coordinators/sponsor_15.png": 1160,
	"./sponsors-coordinators/sponsor_16.png": 1161,
	"./sponsors-coordinators/sponsor_17.png": 1162,
	"./sponsors-coordinators/sponsor_18.png": 1163,
	"./sponsors-coordinators/sponsor_19.png": 1164,
	"./sponsors-coordinators/sponsor_20.png": 1165,
	"./sponsors-coordinators/sponsor_21.png": 1166,
	"./sponsors-coordinators/sponsor_22.png": 1167,
	"./sponsors-coordinators/sponsor_23.png": 1168,
	"./sponsors-coordinators/sponsor_24.png": 1169,
	"./sponsors-coordinators/sponsor_25.png": 1170,
	"./sponsors-coordinators/sponsor_3.png": 1171,
	"./sponsors-coordinators/sponsor_4.png": 1172,
	"./sponsors-coordinators/sponsor_5.png": 1173,
	"./sponsors-coordinators/sponsor_6.png": 1174,
	"./sponsors-coordinators/sponsor_7.png": 1175,
	"./sponsors-coordinators/sponsor_8.png": 1176,
	"./sponsors-coordinators/sponsor_9.png": 1177,
	"./sponsors-coordinators/sponsor_artesia.png": 1178,
	"./sponsors-coordinators/sponsor_eSemneaza.png": 1179,
	"./sponsors-coordinators/sponsor_electryphy.png": 1180,
	"./sports/padel.svg": 1181,
	"./sports/table-tennis.svg": 1182,
	"./sports/tennis.svg": 1183,
	"./sportya_og.jpg": 1184,
	"./start-group-chat-icon.svg": 1185,
	"./stop-icon.svg": 1186,
	"./store-icon.svg": 1187,
	"./stripe-logo.svg": 1188,
	"./summer-plan-icon.svg": 1189,
	"./tab-placeholder.png": 1190,
	"./tennis-ball-turqoise.svg": 1191,
	"./tennis-racket-icon.svg": 1192,
	"./tennis_racket.svg": 1193,
	"./test_avatar1.png": 1194,
	"./three-dots-icon.png": 1195,
	"./three-dots-icon.svg": 1196,
	"./titles-tab/gold.svg": 1197,
	"./titles-tab/league.svg": 1198,
	"./titles-tab/platinum.svg": 1199,
	"./titles-tab/silver.svg": 1200,
	"./titles-tab/special.svg": 1201,
	"./twitter-icon-black.svg": 1202,
	"./twitter-icon.svg": 1203,
	"./vending-icon.svg": 1204,
	"./view-profile-outline-icon.svg": 1205,
	"./wallet-icon.svg": 1206,
	"./wallet.svg": 1207,
	"./walletNegative.svg": 1208,
	"./walletUnavailable.svg": 1209,
	"./welcome/bg.png": 1210,
	"./welcome/icon-star.svg": 1211,
	"./white-arrow-down.svg": 1212,
	"./white-arrow-right.svg": 1213,
	"./white-conversations-icon.svg": 1214,
	"./white-globe-icon.svg": 1215,
	"./white-long-up-arrow-icon.svg": 1216,
	"./wildcard.svg": 1217,
	"./women-icon.svg": 1218,
	"./x-button.svg": 1219,
	"./youtube-icon.svg": 1220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;